/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import React from 'react';
import Block from 'wfui-digital-core/es/Block';
import Markup from 'wfui-digital-core/es/Markup';
import ArrowIcon from 'wfui-digital-core/es/ArrowIcon';
import TriangleIcon from 'wfui-digital-core/es/TriangleIcon';
import NavigationButton from './NavigationButton';
import styles from './NavigationBarButton.less';

var NavigationBarButton = function NavigationBarButton(_ref, ref) {
  var item = _ref.item,
      highlighted = _ref.highlighted;
  return /*#__PURE__*/React.createElement(Block, {
    relative: true,
    style: {
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(NavigationButton, {
    ref: ref,
    item: item,
    expanded: highlighted
  }, /*#__PURE__*/React.createElement(Block, {
    layout: true,
    horizontal: true,
    center: true,
    relative: true,
    flexNone: true
  }, /*#__PURE__*/React.createElement(Markup, {
    className: item.hasMenu ? styles.label : '',
    content: item.label
  }), !highlighted && item.hasMenu && /*#__PURE__*/React.createElement(ArrowIcon, {
    width: "5px",
    height: "11px",
    className: styles.arrow
  }))), highlighted && /*#__PURE__*/React.createElement(Block, {
    className: styles.triangle
  }, /*#__PURE__*/React.createElement(TriangleIcon, null)));
};

export default /*#__PURE__*/React.forwardRef(NavigationBarButton);